<template>
    <i role="button"  :class="{'float-end': float=='end'}" class="fa-solid fa-users-viewfinder icon bg-soft-primary text-primary rounded-circle d-inline" @click="showUserModal" v-tooltip :title="$trans.get('__JSON__.Change employee')"></i>
    <Teleport to="body">
        <div class="modal" tabindex="-1" id="usermodal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $trans.get("__JSON__.Change employee") }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3" id="employeeParent">
                            <label for="employee_id">{{ $trans.get("__JSON__.Employee") }}</label>
                            <input type="text" id="employeename" class="form-control form-control-sm" autocomplete="off" />
                            <input type="hidden" v-model="choosen_employee_id" id="employee_id" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            {{ $trans.get("__JSON__.Close") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </Teleport>
</template>

<script>
import { ref, watch } from "vue";

import getEmployees from "../composables/getEmployees";

export default {
    name: "ChangeUser",
    props: {
        employee_id: String,
        float: String
    },
    setup(props) {
            const { employees, employees_error, loadEmployees } = getEmployees();
            loadEmployees().then(response => {

                const acemployees = ref([]);
                employees.value.forEach((item) => {
                    if (item.inactive == false) {
                        const employee = {
                            label: item.lastname + ", " + item.forename,
                            value: item.id,
                        };
                        acemployees.value.push(employee);
                    }
                });

                $('#employeename').autocomplete({
                    source: acemployees.value,
                    appendTo: '#employeeParent'
                });
            });

            return { employees };
    },
    data() {
        return {
            choosen_employee_id: null,
        };
    },
    created() {
        console.log('EmployeeId', this.employee_id);
    },
    mounted() {
        var self = this;

        $('#employeename').on("autocompleteselect", function (event, ui) {
            $(this).val(ui.item.label);
            self.choosen_employee_id = ui.item.value;

            document.location.href = document.location.href
            .replace('employees/' + self.employee_id, 'employees/' + self.choosen_employee_id)
            .replace('=' + self.employee_id, '=' + self.choosen_employee_id);

            return false;
        });

    },
    computed: {
        autocompleteemployees() {
            var acemployees = [];
            if (this.employees != null) {
                this.employees.forEach((item) => {
                    if (item.inactive == false) {
                        const employee = {
                            label: item.lastname + ", " + item.forename,
                            value: item.id,
                        };
                        acemployees.push(employee);
                    }
                });
            }
            return acemployees;
        },
    },
    methods: {
        fetchData() {
        },
        showUserModal() {
            $("#usermodal").modal("show");
        }
    }
}
</script>

<style lang="scss"></style>
